/* Prozone B2B — pz-catalogue.js
   Filtrage du catalogue dans le navigateur.

   Règle : OU à l'intérieur d'un groupe de facettes, ET entre les groupes.
   VIBES + Yocan  → les produits des deux marques.
   Engrais + rootinn → les engrais rootinn.

   Toutes les cartes du catalogue sont dans la page (voir pz-catalogue.liquid) ;
   filtrer revient à les masquer ou les montrer, sans rechargement. Chaque
   carte porte ses tags entre barres dans data-pz-tags (|engrais|rootinn|).

   L'état vit dans l'URL (?f=vibes,yocan), remplacé sans créer d'entrée
   d'historique : un lien copié rouvre la même sélection, et le bouton
   Précédent ramène à la page d'avant plutôt qu'au clic d'avant.

   Sans JavaScript, les facettes restent des liens serveur valides. */
(function () {
  'use strict';

  var root = document.getElementById('pz-cat');
  var cfgEl = document.getElementById('pz-cat-cfg');
  if (!root || !cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var cards = $$('#pz-grid .pzb-pcard');
  var facets = $$('.pzb-facet[data-pz-tag]');
  var countEl = document.getElementById('pz-count');
  var activeBox = document.getElementById('pz-active');
  var chipsEl = document.getElementById('pz-chips');
  var clearEl = document.getElementById('pz-clear');
  var emptyEl = document.getElementById('pz-empty-js');
  var sortEl = document.getElementById('pz-sort');

  /* ----- Tiroir de filtres (mobile) ----- */
  var drawer   = document.getElementById('pz-facets');
  var openBtn  = document.getElementById('pz-fopen');
  var closeBtn = document.getElementById('pz-fclose');
  var applyBtn = document.getElementById('pz-fapply');
  var backdrop = document.getElementById('pz-fbackdrop');
  var fcountEl = document.getElementById('pz-fcount');
  var seeTpl   = applyBtn ? (applyBtn.getAttribute('data-label') || '') : '';

  function setDrawer(on) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', on);
    if (backdrop) backdrop.hidden = !on;
    document.body.classList.toggle('pz-fdraw-lock', on);
    if (openBtn) openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on && closeBtn) closeBtn.focus();
    else if (!on && openBtn && document.activeElement && drawer.contains(document.activeElement)) openBtn.focus();
  }
  if (openBtn)  openBtn.addEventListener('click', function () { setDrawer(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  if (applyBtn) applyBtn.addEventListener('click', function () { setDrawer(false); });
  if (backdrop) backdrop.addEventListener('click', function () { setDrawer(false); });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && drawer && drawer.classList.contains('is-open')) setDrawer(false);
  });

  var groupOf = {};
  var labelOf = {};
  facets.forEach(function (f) {
    var tag = f.getAttribute('data-pz-tag');
    groupOf[tag] = f.getAttribute('data-pz-group');
    var l = f.querySelector('.pzb-facet-label');
    labelOf[tag] = l ? l.textContent.trim() : tag;
  });

  function has(card, tag) {
    return card.getAttribute('data-pz-tags').indexOf('|' + tag + '|') !== -1;
  }

  /* Nombre de produits par facette, sur tout ce qui est rendu : une
     indication stable, qui ne bouge pas à chaque clic. */
  facets.forEach(function (f) {
    var tag = f.getAttribute('data-pz-tag');
    var n = 0;
    cards.forEach(function (c) { if (has(c, tag)) n++; });
    var slot = f.querySelector('[data-pz-count]');
    if (slot) slot.textContent = '(' + n + ')';
  });


  /* ----- État ----- */

  var selected = {};

  (function initState() {
    var params = new URLSearchParams(window.location.search);
    var f = params.get('f');
    if (f) {
      f.split(',').forEach(function (t) {
        t = t.trim().toLowerCase();
        if (groupOf[t] !== undefined) selected[t] = true;
      });
      return;
    }
    /* Arrivée par un tag dans le chemin (/collections/all/vibes) : le
       serveur a déjà coché les bonnes facettes. */
    facets.forEach(function (el) {
      if (el.classList.contains('pzb-facet--on')) selected[el.getAttribute('data-pz-tag')] = true;
    });
  })();

  function selectedList() {
    return Object.keys(selected).filter(function (t) { return selected[t]; });
  }

  function byGroup() {
    var g = {};
    selectedList().forEach(function (t) {
      var k = groupOf[t];
      (g[k] = g[k] || []).push(t);
    });
    return g;
  }


  /* ----- Rendu ----- */

  var plural = window.Intl && Intl.PluralRules ? new Intl.PluralRules(CFG.lang || 'fr') : null;

  function countText(n) {
    var one = plural ? plural.select(n) === 'one' : n === 1;
    var txt = one ? CFG.countOne.replace('1', String(n)) : CFG.countOther.replace('987654', String(n));
    if (n !== CFG.total) txt += ' ' + CFG.countOf;
    return txt;
  }

  function renderChips(list) {
    chipsEl.textContent = '';
    list.forEach(function (t) {
      var a = document.createElement('a');
      a.className = 'pzb-chip pzb-chip--on';
      a.href = CFG.base + '/' + t;
      a.rel = 'nofollow';
      a.setAttribute('data-pz-remove', t);
      a.appendChild(document.createTextNode(labelOf[t] + ' '));
      a.insertAdjacentHTML('beforeend',
        '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>');
      chipsEl.appendChild(a);
    });
    activeBox.hidden = list.length === 0;
  }

  function buildUrl(extra) {
    var params = new URLSearchParams(window.location.search);
    params.delete('f');
    params.delete('page');
    if (extra) Object.keys(extra).forEach(function (k) { params.set(k, extra[k]); });
    var list = selectedList();
    if (list.length) params.set('f', list.join(','));
    var qs = params.toString();
    /* Toujours le chemin de base, sans tag : c'est lui qui respecte le tri. */
    return CFG.base + (qs ? '?' + qs.replace(/%2C/gi, ',') : '');
  }

  function apply(updateUrl) {
    var groups = byGroup();
    var keys = Object.keys(groups);
    var visible = 0;

    cards.forEach(function (c) {
      var ok = keys.every(function (k) {
        return groups[k].some(function (t) { return has(c, t); });
      });
      c.hidden = !ok;
      if (ok) visible++;
    });

    facets.forEach(function (f) {
      var on = !!selected[f.getAttribute('data-pz-tag')];
      f.classList.toggle('pzb-facet--on', on);
      f.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    if (countEl) countEl.textContent = countText(visible);

    var nSel = selectedList().length;
    if (fcountEl) { fcountEl.textContent = String(nSel); fcountEl.hidden = nSel === 0; }
    if (applyBtn && seeTpl) applyBtn.textContent = seeTpl.replace('987654', String(visible));

    renderChips(selectedList());
    if (emptyEl) emptyEl.hidden = visible !== 0;

    if (updateUrl && window.history && history.replaceState) {
      history.replaceState(null, '', buildUrl());
    }
  }


  /* ----- Interactions ----- */

  function toggle(tag) {
    selected[tag] = !selected[tag];
    apply(true);
  }

  function clearAll() {
    selected = {};
    apply(true);
  }

  facets.forEach(function (f) {
    f.addEventListener('click', function (e) {
      e.preventDefault();
      toggle(f.getAttribute('data-pz-tag'));
    });
    /* role="checkbox" : la barre d'espace coche, comme sur une vraie case. */
    f.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggle(f.getAttribute('data-pz-tag'));
      }
    });
  });

  chipsEl.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-pz-remove]');
    if (!chip) return;
    e.preventDefault();
    selected[chip.getAttribute('data-pz-remove')] = false;
    apply(true);
  });

  if (clearEl) clearEl.addEventListener('click', function (e) { e.preventDefault(); clearAll(); });
  $$('[data-pz-clear]').forEach(function (b) { b.addEventListener('click', clearAll); });

  /* Le tri se fait côté serveur : on recharge sur le chemin sans tag, en
     gardant la sélection dans ?f=. */
  if (sortEl) {
    sortEl.addEventListener('change', function () {
      window.location.href = buildUrl({ sort_by: sortEl.value });
    });
  }

  apply(false);


  /* ----- Facettes natives (disponibilité) : restent des liens serveur -----
     Cliquer recharge la page ; on mémorise la position pour ne pas repartir
     en haut. sessionStorage, pas localStorage : rien ne doit survivre à
     l'onglet. */
  var KEY = 'pz-cat-scroll';
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.pzb-facet:not([data-pz-tag])');
    if (!link) return;
    try { sessionStorage.setItem(KEY, String(window.scrollY)); } catch (err) {}
  });
  var y = null;
  try { y = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (err) {}
  if (y !== null) {
    var top = parseInt(y, 10);
    if (!isNaN(top) && top > 0) {
      requestAnimationFrame(function () {
        var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        window.scrollTo(0, Math.min(top, max));
      });
    }
  }
})();
